// extracted by mini-css-extract-plugin
export var headerWrapper = "instagramFeed-module--headerWrapper--BT6V2";
export var instaHandle = "instagramFeed-module--instaHandle--jVryd";
export var instaImage = "instagramFeed-module--instaImage--J6suW";
export var instaImageFlex = "instagramFeed-module--instaImageFlex--zyI+s";
export var instaImageFlexWrapper = "instagramFeed-module--instaImageFlexWrapper--bu4yc";
export var joinUs = "instagramFeed-module--joinUs--gc+c0";
export var marqueeWrapper = "instagramFeed-module--marqueeWrapper--zSbBH";